import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Redirect, Route, Switch, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginActionTypes, unsavedFormChangesActionTypes } from '../src/redux/actionTypes';
import AppLayout from './containers/Layout';
import jwtDecode from 'jwt-decode';
import { socket } from './utils/service';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { idleSessionTimeout, toastContainerProps, toastType } from './constants/app.constants';
import ForgotPassword from './pages/ResetPassword/ForgotPassword';
import ResetPasswordExpired from './pages/ResetPassword/ResetPasswordExpired';
import { IdleSessionTimeout } from 'idle-session-timeout';
import { showAlert } from './utils/helpers/toastify';
import { updateFormChanges } from './redux/actions';
import useCrossTabIdleLogout from './utils/hooks/useCrossTabIdleLogout';
import HomePageNew from './components/HomePageNew/HomePageNew';
import { getPriceDetails } from './redux/thunks/priceDetails';
import {loadInitialData} from './redux/thunks/rateConversion';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

//Importing Components
const Login = React.lazy(() => import('./pages/Login'));
const Home = React.lazy(() => import('./components/Home'));
const PageNotFound = React.lazy(() => import('./components/PageNotFound/PageNotFound'));

function App() {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.login);
  const history = useHistory();
  const [alertMessage, setAlertMessage] = useState('');

  useEffect(() => {
    dispatch(getPriceDetails());
    const token = localStorage.getItem('token');
    if (token) {
      const { exp } = jwtDecode(token);
      if (exp < Date.now() / 1000) {
        dispatch({ type: loginActionTypes.LOGOUT });
        if (history) history.push('/');
      }
    }
  }, [dispatch, history]);

   useEffect(() => {
      dispatch(loadInitialData());
    }, [dispatch]);

  // let session = new IdleSessionTimeout(idleSessionTimeout.milliseconds);
  // session.onTimeOut = () => {
  //   dispatch(updateFormChanges(unsavedFormChangesActionTypes.RESET_FORM_CHANGES));
  //   setAlertMessage({ type: toastType.info, message: idleSessionTimeout.message });
  //   dispatch({ type: loginActionTypes.LOGOUT });
  //   if (history) history.push("/");
  // };

  const removeAlert = () => {
    setAlertMessage('');
  };

  // useEffect(() => {
  //   if (isLoggedIn.success) {
  //     session.start();
  //     socket.initiateSocket();
  //   }
  //   return () => {
  //     socket.removeListener();
  //   };
  // }, [isLoggedIn.success]);
  useCrossTabIdleLogout(isLoggedIn.success, history);

  useEffect(() => {
    if (alertMessage && alertMessage.type && alertMessage.message) {
      showAlert({ type: alertMessage.type, message: alertMessage.message });
      removeAlert();
    }
  }, [alertMessage]);

  return (
    <BrowserRouter>
      <React.Suspense fallback={loading}>
        <ToastContainer {...toastContainerProps} />
        <Switch>
          <Route path="/" exact name="Home Page" render={(props) => <HomePageNew {...props} />} />
          <Route exact path="/login" name="Login" render={(props) => <Login {...props} />} />
          <Route
            exact
            path="/account/reset-password"
            name="Reset Password"
            render={(props) => <Login {...props} />}
          />
          <Route
            path="/controlroom"
            name="Dashboard"
            render={(props) => <AppLayout {...props} />}
          />
          <Route
            path="/login/reset-password"
            name="Reset Password"
            render={(props) => <Login {...props} />}
          />
          <Route
            exact
            path="/account/forgot-password"
            name="Forgot Password"
            render={(props) => <ForgotPassword {...props} />}
          />
          <Route
            exact
            path="/account/reset-password-expired"
            name="Reset Password Expired"
            render={(props) => <ResetPasswordExpired {...props} />}
          />
          <Route
            exact
            path="/404"
            name="Page Not Found"
            render={(props) => <PageNotFound {...props} />}
          />
          <Route path="/notfound" exact component={PageNotFound} />
          <Redirect from="*" to="/notfound" />
        </Switch>
      </React.Suspense>
    </BrowserRouter>
  );
}

export default App;
